module.exports = __webpack_public_path__ + "static/media/icon-hospedagem.c8eefdb6.svg";